module.exports = __webpack_public_path__ + "media/assets/images/flags/mw-943534fba4c57af3a50d33452bcbf680.svg";